var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ValidationObserver',{ref:"observer",attrs:{"tag":"form"},on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_c('FormLesiones',{attrs:{"form":_vm.form}}),_c('b-button',{attrs:{"disabled":_vm.isAdd,"type":"submit"}},[_vm._v("Crear")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }